<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Audit Changes</h1>
      <p-table
        class="break-word-cells"
        [value]="page.items"
        [rows]="20"
        [responsive]="true"
        [paginator]="true"
        [totalRecords]="page.total"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="stateString">State</th>
            <th pSortableColumn="entityName">Entity</th>
            <th pSortableColumn="entityId">Entity Id</th>
            <th pSortableColumn="userName">User</th>
            <th pSortableColumn="dateTime">Date</th>
            <th>Change Log</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.stateString }}</td>
            <td>{{ item.entityName }}</td>
            <td>{{ item.entityId }}</td>
            <td>{{ item.userName }}</td>
            <td>
              <span>{{ item.dateTime | date : 'short' }}</span>
            </td>
            <td>{{ item.changeLogItemsText }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DEPRECATED --
            <p-dataTabl class="break-word-cells" [value]="page.items" [rows]="20" [responsive]="true" [paginator]="true"
                [totalRecords]="page.total">
                <p-header>List of Changes</p-header>
                <p-column field="stateString" header="State" [sortable]="tru"></p-column>
                <p-column field="entityName" header="Entity" [sortable]="tru"></p-column>
                <p-column field="entityId" header="Entity Id" [sortable]="tru"></p-column>
                <p-column field="userName" header="User" [sortable]="tru"></p-column>
                <p-column field="dateTime" header="Date" [sortable]="tru">
                    <ng-template let-col let-audit="rowData" pTemplate="body">
                        <span>{{audit[col.field] | date: 'short'}}</span>
                    </ng-template>
                </p-column>
                <p-column field="changeLogItemsText" header="Change Log" styleClass="values-column"></p-column>
            </p-dataTable>
            -->
    </div>
  </div>
</div>
